import styled from 'styled-components';

export const SlideOutContainer = styled.div`
  position: relative;
  width: ${({ $width }) => ($width ? `${$width}px` : `${Math.round(window.innerWidth / 3)}px`)};
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  background: ${({ theme }) => theme.colors.white};

  padding: 24px 24px 0 24px;
  gap: 16px;
`;

export const ChatPanelWrapper = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;
  background: radial-gradient(77.51% 157.3% at 18.46% 91.07%, #f6f9ff 0%, #ffffff 80.17%);
  padding: 8px 0px 24px 0px;
`;

/**
 * Drag handle on the left edge.
 * 3 visual states per Figma: Default (0.5px neutral-lighter), Hover (1px neutral), Grab/Active (1px primary blue).
 */
export const DragHandle = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 8px;
  cursor: col-resize;
  z-index: 10;

  &::after {
    content: '';
    position: absolute;
    left: 3px;
    top: 0;
    bottom: 0;
    width: 1px;
    background: ${({ theme }) => theme.colors.neutral ?? '#9CA3AF'};
    transition: background 0.15s ease;
  }

  &:active::after,
  &[data-dragging='true']::after {
    width: 1px;
    background: ${({ theme }) => theme.colors.primary ?? '#2173FF'};
  }
`;
